export class CopyrightCheckerDossierTableColumns {
    static Confirm = {
        translateKey: 'copyright_checker.detection.confirm',
    };
    static Confirmed = {
        translateKey: 'copyright_checker.detection.confirmed',
    };
    static SourceImage = {
        translateKey: 'copyright_checker.detection.source_image',
    };
    static DetectionType = {
        translateKey: 'copyright_checker.detection.detection_type',
    };
    static Location = {
        translateKey: 'copyright_checker.detection.location',
    };
    static CreatedAt = {
        translateKey: 'copyright_checker.detection.created_at',
    };
    static Dimensions = {
        translateKey: 'copyright_checker.detection.dimensions',
    };
    static Screenshot = {
        translateKey: 'copyright_checker.detection.screenshot',
    };
    static Actions = {
        maxWidth: '4%',
        translateKey: '',
    };
}
